import {
  SpecialOutlineButtonLink,
  SpecialButton,
} from '@chegg-wt/core/theme/fanta/button'
import styled from 'styled-components'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    align-items: center;
  }
`

export const BackButton = styled(SpecialOutlineButtonLink)`
  &&& {
    margin: 4px 16px;
    @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
      width: 30%;
    }
  }
`

export const ContinueButton = styled(SpecialButton)`
  &&& {
    margin: 4px 16px;
    @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
      width: 30%;
    }
  }
`

export const NavBorder = styled.div.attrs({
  role: 'region',
  'aria-label': 'Confirm Citation',
})`
  margin-bottom: ${(props) => props.theme.spacing.md} !important;
`

export const EvalNav = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColor};
  border-top: 1px solid ${(props) => props.theme.colors.borderColor};
  margin-bottom: -1px;
  margin-top: 10px;
  padding: 20px;

  & > * {
    flex-basis: 100%;
    margin-top: 11px;
    margin-bottom: 11px;
  }

  @media only screen and (min-width: ${({ theme }) =>
      adjust(themeBreakPoints.extraSmall(theme), -110)}) {
    justify-content: space-between;

    & > * {
      flex-basis: 200px;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`
